module.exports = __webpack_public_path__ + "static/media/Icon-notifications.467e9044.svg";